var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolePermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.875 5.5C6.875 3.22183 8.72182 1.375 11 1.375C13.2782 1.375 15.125 3.22183 15.125 5.5C15.125 7.77817 13.2782 9.625 11 9.625C8.72182 9.625 6.875 7.77817 6.875 5.5Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43864 18.4299C3.50954 14.3143 6.86765 11 11 11C15.1324 11 18.4906 14.3144 18.5614 18.4302C18.5661 18.7031 18.4088 18.953 18.1607 19.0669C15.98 20.0675 13.5543 20.625 11.0003 20.625C8.44604 20.625 6.02015 20.0674 3.83929 19.0666C3.59118 18.9527 3.43394 18.7028 3.43864 18.4299Z",
    fill: "#232323"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 10,
    height: 10,
    rx: 5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9256 12.6124C14.9613 12.4307 15.1179 12.2998 15.2997 12.2998H16.2003C16.3821 12.2998 16.5387 12.4307 16.5744 12.6124L16.7005 13.255C16.9692 13.3594 17.2171 13.5067 17.4362 13.6887L18.0459 13.4784C18.2182 13.419 18.4077 13.4918 18.4986 13.6523L18.9489 14.4473C19.0398 14.6078 19.0069 14.8115 18.8703 14.9338L18.387 15.3668C18.4092 15.5078 18.4206 15.6524 18.4206 15.7998C18.4206 15.9472 18.4092 16.0918 18.387 16.2328L18.8703 16.6658C19.0069 16.7881 19.0398 16.9918 18.9489 17.1523L18.4986 17.9473C18.4077 18.1078 18.2182 18.1806 18.0459 18.1212L17.4362 17.911C17.2171 18.093 16.9692 18.2402 16.7005 18.3446L16.5744 18.9872C16.5387 19.169 16.3821 19.2998 16.2003 19.2998H15.2997C15.1179 19.2998 14.9613 19.169 14.9256 18.9872L14.7995 18.3446C14.5308 18.2402 14.2829 18.093 14.0638 17.911L13.4541 18.1212C13.2818 18.1806 13.0923 18.1078 13.0014 17.9473L12.5511 17.1523C12.4602 16.9918 12.4931 16.7881 12.6297 16.6658L13.113 16.2329C13.0908 16.0918 13.0794 15.9472 13.0794 15.7998C13.0794 15.6524 13.0908 15.5078 13.113 15.3668L12.6297 14.9338C12.4931 14.8115 12.4602 14.6078 12.5511 14.4473L13.0014 13.6523C13.0923 13.4918 13.2818 13.419 13.4541 13.4784L14.0638 13.6887C14.2829 13.5067 14.5308 13.3594 14.7995 13.255L14.9256 12.6124ZM15.75 16.9665C16.3821 16.9665 16.8946 16.4441 16.8946 15.7998C16.8946 15.1555 16.3821 14.6331 15.75 14.6331C15.1179 14.6331 14.6054 15.1555 14.6054 15.7998C14.6054 16.4441 15.1179 16.9665 15.75 16.9665Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolePermission);
export default __webpack_public_path__ + "static/media/role_permission.2719c832eee7a04f377dc1f9fe0eb3f8.svg";
export { ForwardRef as ReactComponent };